import './_product-customizer-form.scss';
import component from './product-customizer-form';

export default component;
